module.exports = __webpack_public_path__ + "static/img/gz.33c8088.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gz.jpg
// module id = 58BK
// module chunks = 1